import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_ARTICLE_CATEGORY } from './../../../const/icons';

import { COMP_BUTTON_ARTICLE_CATEGORY } from './../../../const/components';

import { FIELD_ARTICLE_CATEGORY_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const ArticleCategory = (editor, options:any = {}) => {

  (FIELD_ARTICLE_CATEGORY_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_ARTICLE_CATEGORY,
    displayIcon: ICON_BUTTON_ARTICLE_CATEGORY,
    model: {
      defaults: { ...Defaults,
        name: 'Article Category',
        traits: [ ...Traits, FIELD_ARTICLE_CATEGORY_SELECTOR]
      }
    }
  });
}